import Values from 'values.js'

export function normalizeColor(color) {
    if (color.startsWith('0x')) {
        return `#${color.replace('0x', '')}`
    }
    return color
}

export function getColorShades(color) {
    const shades = new Values(color).all(12)
        .filter((_shade, index, array) => {
            // remove first and last shades
            return !(index === 0 || index === array.length - 1)
        })

    return shades
}

export function getRgb(color) {
    return new Values(color).rgb.join(',')
}

export function getBrightness(color) {
    return new Values(color).getBrightness()
}

export function color(value) {
    return new Values(value)
}